import React, { useEffect, useState } from 'react'

import Container from 'components/Container'
import Row from 'components/Row'
import Col from 'components/Col'
import Select from 'components/Select'
import Input from 'components/Input'

const filterOptions = (options, level1Selected, level2Selected) => {
  return {
    level1Threats: options.level1Threats,
    level2Threats: options.level2Threats.filter((element) => {
      return element.Level1ThreatId === level1Selected
    }),
    level3Threats: options.level3Threats.filter((element) => {
      return element.Level1ThreatId === level1Selected && element.Level2ThreatId === level2Selected
    })
  }
}

const defaultOptionsLength = 1
const defaultThreatLevel3Length = 0
const ThreatsContent = ({ item, options, createThreats, updateThreats, defaultThreatsOptions, disabled }) => {
  const initialLevelOneThreat = defaultThreatsOptions.level1Threats.find((element) => {
    return element.value === item.Level1ThreatId
  })
  const initialLevelTwoThreat = defaultThreatsOptions.level2Threats.find((element) => {
    return element.value === item.Level2ThreatId
  })
  const initialLevelThreeThreat = defaultThreatsOptions.level3Threats.find((element) => {
    return element.value === item.Level3ThreatId
  })
  const initialTimingThreat = defaultThreatsOptions.siteThreatsTiming.find((element) => {
    return element.value === item.SiteThreatTimingId
  })

  const [selectLevelOneThreats, setSelectLevelOneThreats] = useState(initialLevelOneThreat || null)
  const [selectLevelTwoThreats, setSelectLevelTwoThreats] = useState(initialLevelTwoThreat || null)
  const [selectLevelThreeThreats, setSelectLevelThreeTreats] = useState(initialLevelThreeThreat || null)
  const [timing, setTiming] = useState(initialTimingThreat || null)
  const [availableOptions, setAvailableOptions] = useState(
    filterOptions(options, item.Level1ThreatId, item.Level2ThreatId)
  )


  const handleChangeLevelOneThreats = (e) => {
    setAvailableOptions(filterOptions(options, e.value))
    setSelectLevelOneThreats(e)
    setSelectLevelTwoThreats(null)
    setSelectLevelThreeTreats(null)
  }

  const handleChangeLevelTwoThreats = (e) => {
    const result = filterOptions(options, selectLevelOneThreats.value, e.value)
    setAvailableOptions(result)
    setSelectLevelTwoThreats(e)
    setSelectLevelThreeTreats(null)

    if (item.id === '' && result.level3Threats.length === defaultThreatLevel3Length) {
      console.log('threats created')
      createThreats({ Level2ThreatId: e.value })
    } else {
      updateThreats(item.id, { Level2ThreatId: e.value })
    }
  }

  const handleChangeLevelThreeThreats = (e) => {
    setSelectLevelThreeTreats(e)
    if (item.id === '') {
      console.log('threats created')
      return createThreats({ Level3ThreatId: e.value })
    }
    updateThreats(item.id, { Level3ThreatId: e.value })
  }

  const handleChangeTimingThreats = (e) => {
    setTiming(e)
    updateThreats(item.id, { SiteThreatTimingId: e.value })
  }

  useEffect(() => {
    setAvailableOptions(filterOptions(options, item.Level1ThreatId, item.Level2ThreatId))
    setSelectLevelOneThreats(initialLevelOneThreat || null)
    setSelectLevelTwoThreats(initialLevelTwoThreat || null)
    setSelectLevelThreeTreats(initialLevelThreeThreat || null)
    setTiming(initialTimingThreat || null)
  }, [item])

  return (
    <Container width="100%" padding="0px">
      {item.id && (
        <Row>
          <Col md={12}>
            <Input value={item.id} label="threatsId" disabled={true} placeholder='noPlaceholder' infoTooltip='threatsId' />
          </Col>
        </Row>
      )}
      <Row>
        <Col md={6}>
          <Select
            value={selectLevelOneThreats}
            marginTop="16px"
            onChange={handleChangeLevelOneThreats}
            placeholder="selectLevelOneThreat"
            options={availableOptions.level1Threats}
            label="levelOne"
            infoTooltip="levelOneThreatsHint"
            disabled={disabled}
          />
        </Col>
        {(availableOptions.level2Threats.length >= defaultOptionsLength || selectLevelTwoThreats) && (
          <Col md={6}>
            <Select
              value={selectLevelTwoThreats}
              marginTop="16px"
              onChange={handleChangeLevelTwoThreats}
              placeholder="selectLevelTwoThreat"
              options={availableOptions.level2Threats}
              label="levelTwo"
              disabled={disabled}
            />
          </Col>
        )}
      </Row>
      <Row>
        {(availableOptions.level3Threats.length >= defaultOptionsLength || selectLevelThreeThreats) && (
          <Col md={6}>
            <Select
              value={selectLevelThreeThreats}
              marginTop="16px"
              onChange={handleChangeLevelThreeThreats}
              placeholder="selectLevelThreeThreat"
              options={availableOptions.level3Threats}
              label="levelThree"
              disabled={disabled}
            />
          </Col>
        )}
        <Col md={6}>
          {selectLevelOneThreats && (
            <Select
              value={timing}
              marginTop="16px"
              onChange={handleChangeTimingThreats}
              placeholder="selectThreatLevelTiming"
              options={defaultThreatsOptions.siteThreatsTiming}
              label="timing"
              infoTooltip="timingThreatsHint"
              disabled={disabled}
            />
          )}
        </Col>
      </Row>
    </Container>
  )
}

export default ThreatsContent
